// extracted by mini-css-extract-plugin
export var backdropBlur = "_jz-0";
export var contentCard = "_jz-5";
export var frame = "_jz-2";
export var image = "_jz-4";
export var imagePane = "_jz-3";
export var modal = "_jz-1";